var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownCircleInverted = function SvgArrowDownCircleInverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z",
    fill: "#130E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20 27.762 6-6.461-1.111-1.032-4.13 4.448V13h-1.517v11.717l-4.13-4.448L14 21.3l6 6.461Z",
    fill: "#fff"
  })));
};
export { SvgArrowDownCircleInverted as ReactComponent };
export default __webpack_public_path__ + "f592717f4a5be189fa9c461396582ae2.svg";